const getPeriods = (ctx) => {
  return [
    // {
    // 	title: this.$t('stats.today'),
    // 	code: 'today'
    // },
    {
      title: ctx.$t('stats.yesterday'),
      code: 'yesterday'
    },
    {
      title: ctx.$t('stats.currentWeek'),
      code: 'current_week'
    },
    {
      title: ctx.$t('stats.prevWeek'),
      code: 'last_week'
    },
    {
      title: ctx.$t('stats.current_month'),
      code: 'current_month'
    },
    {
      title: ctx.$t('stats.last_month'),
      code: 'last_month'
    },
    {
      title: ctx.$t('stats.last_three_month'),
      code: 'last_three_month'
    },
    {
      title: ctx.$t('stats.last_six_month'),
      code: 'last_six_month'
    },
    {
      title: ctx.$t('stats.last_year'),
      code: 'last_year'
    },
  ]
}

export default getPeriods